import { render, staticRenderFns } from "./QueryGourami.vue?vue&type=template&id=d59a8b7a&"
import script from "./QueryGourami.vue?vue&type=script&lang=js&"
export * from "./QueryGourami.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports